var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "create-client-profile",
        title: "Создание профиля клиента",
        "ok-only": "",
        "ok-title": "Создать"
      },
      on: { shown: _vm.shownModal, ok: _vm.createClient }
    },
    [
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-between align-items-center mb-2"
        },
        [
          _c("b", [_vm._v("Бренд:")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.brandName))])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "Введите имя клиента",
            "label-for": "input-1",
            "invalid-feedback": "Имя клиента не может быть пустым",
            "valid-feedback": "",
            state: _vm.validate
          }
        },
        [
          _c("b-form-input", {
            attrs: { id: "input-1", state: _vm.validate, trim: "" },
            model: {
              value: _vm.clientName,
              callback: function($$v) {
                _vm.clientName = $$v
              },
              expression: "clientName"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-273d95ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-273d95ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/CreateClientProfile.vue
// module id = null
// module chunks = 